<template>
    <div class="aup-tag-select position-relative w-100 p-3">
        <label class="aup-tag-select__label aup-tag-select__label--field-label t-heavy t-micro text-uppercase text-center px-2">error:call:49</label>
        <div class="d-flex flex-wrap pt-1">
            <div class="" v-for="(item, index) in items" :key="index">
                <button @click="toggleItem(item.toLowerCase())" class="aup-tag-select__tag-btn">
                    <BaseTextLabel
                        :color="local_value.indexOf(item.toLowerCase()) > -1 ? 'orange' : 'gray'"
                        :text="item"
                        class="aup-tag-select__tag w-100 mb-0"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseTagSelect",
    props: {
        items: {
            type: Array,
        },
        label: {
            type: String
        },
        value: {
            type: Array,
        }
    },
    watch: {
        local_value(val) {
            this.$emit('input', val);
        }
    },
    computed: {
        isSelected: () => {

        },
    },
    data() {
        return {
            local_value: this.value
        };
    },
    methods: {
        toggleItem(item) {
            if (this.local_value.indexOf(item) > -1) {
                var newArray = [];
                this.local_value.forEach(arrayItem => {
                    if (arrayItem != item) {
                        newArray.push(arrayItem);
                    }
                });
                this.local_value = newArray;
            } else {
                this.local_value.push(item);
            }
        }
    }
};
</script>

<style lang="scss">
     @import "../../assets/scss/all";
    .aup-tag-select {
        position: relative;
        border-style: solid;
        border-width: 1px;
        border-color: $sony-black;

        &__label {
            position: absolute;
            background: $sony-white;
            &--field-label {
                top: 0;
                transform: translateY(-50%);
                left: 7px;
            }
        }

        &__tag-btn {
            display: block;
            -webkit-appearance: none;
            background: transparent;
            border:none;
            padding: 0;
            margin-bottom: 10px;
            margin-right: 10px;

            &:focus {
                outline: 0;
            }

        }

        &__tag {
            cursor: pointer;
        }
    }
</style>
